import { useQuery, type UseQueryOptions } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';
import { getProperties } from '../api-ts';
import type { PropertiesListResponse, RentalManagerResponseType } from '../../models';
import type { AxiosResponse } from 'axios';

type QueryData = AxiosResponse<RentalManagerResponseType<PropertiesListResponse>, any>;

type UseGetPropertiesQueryOptions = Omit<
  UseQueryOptions<QueryData, unknown, QueryData, Array<string>>,
  'queryKey' | 'queryFn' | 'initialData'
> & {
  initialData?: () => undefined;
};

export default function useGetProperties(useQueryOptions: UseGetPropertiesQueryOptions) {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ['getProperties'],
    queryFn: () => dispatch(getProperties()) as Promise<QueryData>,
    ...useQueryOptions,
  });
}
